import { Alert, Cell, Grid } from 'bold-ui'
import { useAcessoLotacaoOrEstagio } from 'components/auth/useAcessoLotacao'
import { LotacaoAndEstagioSelectFieldModel } from 'components/form/field/select/LotacaoAndEstagioSelectField/LotacaoAndEstagioSelectField'
import { usePecField } from 'components/form/final-form/hooks/useField'
import React, { Fragment, useState } from 'react'
import { isUndefinedOrNull } from 'util/checks'
import { MetaPath } from 'util/metaPath'
import {
  MENSAGEM_RESPONSAVEL_ACOMPANHAMENTO_CBO_SEM_PERMISSAO_CIDADAO,
  MENSAGEM_RESPONSAVEL_ACOMPANHAMENTO_CBO_SEM_PERMISSAO_IMOVEL,
  MENSAGEM_RESPONSAVEL_ACOMPANHAMENTO_SEM_CBO,
  MENSAGEM_RESPONSAVEL_NAO_INFORMADO,
} from 'view/cadastro-imovel/model-cadastroImovel'

import { EditarLotacaoResponsavelModal } from './EditarLotacaoResponsavelModal'
import { LotacaoResponsavelCard } from './LotacaoResponsavelCard'
import { LotacaoResponsavelFormModel } from './model-lotacaoResponsavel'

interface LotacaoResponsavelSectionProps {
  name: MetaPath<LotacaoResponsavelFormModel>
  isCadastroImovel?: boolean
  isCadastroIndividual?: boolean
  isAtividadeColetiva?: boolean
  isLotacaoActive?: boolean
  loadItemsOnOpen?: boolean
}

export function LotacaoResponsavelSection(props: LotacaoResponsavelSectionProps) {
  const { name, isCadastroImovel, isCadastroIndividual, isAtividadeColetiva, isLotacaoActive, loadItemsOnOpen } = props
  const { acesso } = useAcessoLotacaoOrEstagio()
  const [isModalResponsavelOpen, setIsModalResponsavelOpen] = useState(false)

  const {
    input: {
      value: { lotacao },
      onChange,
    },
  } = usePecField({ name: name.absolutePath() })

  const handleEditarLotacaoResponsavel = (novoResponsavel: LotacaoAndEstagioSelectFieldModel) => {
    onChange({ lotacao: novoResponsavel })
  }

  const errorMessage = getLotacaoErrorMessage(lotacao, isCadastroImovel, isCadastroIndividual)
  return (
    <Fragment>
      <Grid>
        <Cell size={12}>
          <LotacaoResponsavelCard
            responsavel={lotacao}
            isLotacaoActive={isLotacaoActive}
            onAlterarResponsavel={() => setIsModalResponsavelOpen(true)}
          />
        </Cell>
        {(isCadastroImovel || isCadastroIndividual) && errorMessage && (
          <Fragment>
            <Cell size={7}>
              <Alert type='danger'>{errorMessage}</Alert>
            </Cell>
            <Cell size={5} />
          </Fragment>
        )}
      </Grid>

      <EditarLotacaoResponsavelModal
        open={isModalResponsavelOpen}
        municipioId={acesso.municipio.id}
        onClose={() => setIsModalResponsavelOpen(false)}
        onResponsavelChange={handleEditarLotacaoResponsavel}
        isCadastroImovel={isCadastroImovel}
        isAtividadeColetiva={isAtividadeColetiva}
        loadItemsOnOpen={loadItemsOnOpen}
      />
    </Fragment>
  )
}

const getLotacaoErrorMessage = (
  lotacao: LotacaoAndEstagioSelectFieldModel,
  isCadastroImovel: boolean,
  isCadastroIndividual: boolean
) => {
  if (isUndefinedOrNull(lotacao.profissional)) {
    return MENSAGEM_RESPONSAVEL_NAO_INFORMADO
  }

  if (isUndefinedOrNull(lotacao.cbo)) {
    return MENSAGEM_RESPONSAVEL_ACOMPANHAMENTO_SEM_CBO
  }

  if (isCadastroImovel && !lotacao.cbo.actions?.cadastroDomiciliar?.enabled) {
    return MENSAGEM_RESPONSAVEL_ACOMPANHAMENTO_CBO_SEM_PERMISSAO_IMOVEL
  }

  if ((isCadastroImovel || isCadastroIndividual) && !lotacao.cbo.actions?.cadastroIndividual.enabled) {
    return MENSAGEM_RESPONSAVEL_ACOMPANHAMENTO_CBO_SEM_PERMISSAO_CIDADAO
  }
}
